import { Component, OnInit } from '@angular/core';
import { ClinicService } from 'src/app/_services/clinic.service';
import { UserService } from 'src/app/_services';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormArray, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-nurse-assignment-dialog',
  templateUrl: './nurse-assignment-dialog.component.html',
  styleUrls: ['./nurse-assignment-dialog.component.scss']
})
export class NurseAssignmentDialogComponent implements OnInit {
  nurses: any[] = [];
  selectedNurses: any;
  submitted = false;
  loading = false;
  data: any;
  fullName: string = '';

  constructor(
    private clinicService: ClinicService,
    private userService: UserService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private fb: FormBuilder
  ) { }

  nurseAssignmentForm: FormGroup = this.fb.group({
    user_id: this.fb.control([], Validators.required),
    id: this.fb.control(this.config.data.clinic.clinic_id),
  });

  ngOnInit(): void {
    this.data = this.config.data;
    console.log(this.data);

    this.clinicService.getNurses(this.data.clinic.id).subscribe((response: any) => {
      this.nurses = response.body;
      console.log(response.body);
      this.nurses.forEach((nurse: any) => {
        nurse.fullName = `${nurse.first_name} ${nurse.last_name}`;
        this.fullName = nurse.fullName;
      });
      
    });

  }

  get f() {
    return this.nurseAssignmentForm.controls;
  }

  getNurseName(nurseId: number): string {
    const nurse = this.nurses.find(n => n.id === nurseId);
    return nurse ? nurse.fullName : 'Unknown Nurse';
  }

  removeNurse(nurseId: number) {
    const currentSelection = this.nurseAssignmentForm.get('user_id')?.value || [];
    const updatedSelection = currentSelection.filter((id: number) => id !== nurseId);
    this.nurseAssignmentForm.patchValue({ user_id: updatedSelection });
  }

  closeDialog() {
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    if (this.nurseAssignmentForm.valid) {
      console.log(this.nurseAssignmentForm.value);
      this.nurseAssignmentForm.value.id = this.data.clinic.id;

      this.clinicService.assignNurseToClinic(this.nurseAssignmentForm.value).subscribe(
        (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Nurse(s) assigned successfully!',
          });
          this.ref.close();
        },
        (error: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to assign nurse(s). Please try again.',
          });
          this.loading = false;
        }
      );
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one nurse.',
      });
      this.loading = false;
    }
  }
}
